import { Skeleton } from '@r/components/ui/skeleton.tsx';
import { Card } from '@ui/card.tsx';

const CartInterfaceSkeleton = () => (
  <Card className="sticky p-5 rounded-none top-10 xl:top-5 bg-body sm:bg-background sm:rounded-3xl xl:border-0 xl:p-10">
    <div className="space-y-3 md:space-y-0 md:space-x-2 xl:space-x-0 xl:space-y-5 md:flex md:items-end xl:block">
      <div className="flex items-end space-x-2 md:w-2/3 xl:w-full xl:flex-wrap xl:space-x-0 xl:space-y-5">
        <Skeleton className="hidden w-4/5 h-8 mx-auto mb-2 xl:block" />

        <div className="w-1/2 xl:w-full">
          <Skeleton className="h-5 w-24 mb-2.5" />
          <Skeleton className="w-full h-10 rounded-full" />
        </div>

        <div className="w-1/2 xl:w-full">
          <Skeleton className="h-5 w-24 mb-2.5" />
          <Skeleton className="w-full h-10 rounded-full" />
        </div>

        <Skeleton className="hidden w-full h-6 xl:block" />
      </div>

      <div className="flex h-10 md:w-1/3 xl:w-full">
        <Skeleton className="w-10 h-10 mr-2 rounded-full md:hidden" />
        <Skeleton className="w-full h-10 rounded-full" />
      </div>
    </div>
  </Card>
);

export { CartInterfaceSkeleton };
